/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditor } from "../../IEditor";

export function registerMenus(dc: IEditor): void {
	const menuSvc = dc.get("menuService");

	menuSvc.registerMenuItem("main.create", {
		id: "readme",
		label: "Readme",
		tooltip: "Create a new readme document for developer notes and documentation.",
		icon: "mdi/file-document",
		flags: [ "primary" ],
		order: 120,
		commandId: "readmeEditor.create.open"
	});
}
